import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, useParams } from "react-router-dom";
import AuthenticationRoutes from "./routes/AuthenticationRoutes.js";
import { ToastContainer } from "react-toastify";
import UnAuthenticationRoutes from "./routes/UnAuthenticationRoutes.js";
import { useSelector } from "react-redux";

const App = () => {

  const { email, token } = useSelector(state => state.userState);
  // if(true){
  //   console.log = function no_console() { };
  // }
  return (
    <>
      <ToastContainer />
      {email && token ? (
        <>
          <Router>
            <AuthenticationRoutes />
          </Router>
        </>
      ) :
        <UnAuthenticationRoutes />
      }
    </>
  );
};

export default App;
